import script from "./AgendamentoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendamentoCard.vue?vue&type=script&setup=true&lang=js"

import "./AgendamentoCard.vue?vue&type=style&index=0&id=4570466b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4570466b"]])

export default __exports__